import { createFileRoute } from '@tanstack/react-router';
import ObjectsIndexPage from '@/pages/workspaces/objects/index.page';
import { ObjectsRoute } from '@/pages/workspaces/objects/routing';
import { RumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/')({
  component: () => (
    <ObjectsRoute>
      <RumPageRendered>
        <ObjectsIndexPage />
      </RumPageRendered>
    </ObjectsRoute>
  ),
});
